export default __webpack_public_path__ + "b5c03cf4bf5ff232e214f80e0ad27b4f.png";